// extracted by mini-css-extract-plugin
export var button = "newsletterSection-module--button--b596d";
export var checkbox = "newsletterSection-module--checkbox--5d3b6";
export var checkboxW = "newsletterSection-module--checkboxW--b79f0";
export var confirmation = "newsletterSection-module--confirmation--32697";
export var contact = "newsletterSection-module--contact--68961";
export var contacts = "newsletterSection-module--contacts--31f0e";
export var content = "newsletterSection-module--content--e19cb";
export var email = "newsletterSection-module--email--01656";
export var footer = "newsletterSection-module--footer--b8ea4";
export var form = "newsletterSection-module--form--cc52f";
export var image = "newsletterSection-module--image--5395f";
export var imageDesktop = "newsletterSection-module--imageDesktop--96794";
export var labelW = "newsletterSection-module--labelW--d90e4";
export var name = "newsletterSection-module--name--b11dc";
export var optin = "newsletterSection-module--optin--0ccef";
export var overlay = "newsletterSection-module--overlay--617e6";
export var warning = "newsletterSection-module--warning--f336d";
export var wrapper = "newsletterSection-module--wrapper--250f5";
export var wrapperCheckbox = "newsletterSection-module--wrapperCheckbox--088af";